<script setup lang="ts">
  import type { ItemSelectorGroup, ItemSelectorOption } from '@/types/item-selector-option'
  import { computed, type ComputedRef } from 'vue'
  const { availableOptions, groups } = defineProps<{
    availableOptions: ItemSelectorOption[]
    groups: ItemSelectorGroup[]
  }>()

  const remainingOptions = computed(() => {
    return availableOptions.filter(option => !selected.value.includes(option.id))
  })

  const remainingGroups = computed(() => {
    return groups.filter(group =>
      availableOptions.some(
        option => option.group === group.id && !selected.value.includes(option.id)
      )
    )
  })

  const selectedOptions: ComputedRef<ItemSelectorOption[]> = computed(() => {
    return availableOptions.filter(option => selected.value.includes(option.id))
  })

  const selectedGroups = computed(() => {
    return groups.filter(group =>
      availableOptions.some(
        option => option.group === group.id && selected.value.includes(option.id)
      )
    )
  })

  const selected = defineModel<number[]>({ default: () => [] })
</script>

<template>
  <div class="container">
    <div class="column">
      <h2>Beschikbare Modules</h2>
      <div class="column-body">
        <div
          v-for="item in remainingOptions.filter(option => option.group == null)"
          :key="item.id"
          @click="selected.push(item.id)"
        >
          <p>{{ item.id }} - {{ item.label }}</p>
        </div>
        <div v-for="group in remainingGroups" :key="group.id" class="group">
          <h3>{{ group.label }}</h3>
          <div
            v-for="item in remainingOptions.filter(option => option.group === group.id)"
            class="item"
            :key="item.id"
            @click="selected.push(item.id)"
          >
            <p>{{ item.id }} - {{ item.label }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <h2>Toegekende Modules</h2>
      <div class="column-body">
        <div
          v-for="item in selectedOptions.filter(option => option.group == null)"
          class="item"
          :key="item.id"
        >
          <p>{{ item.id }} - {{ item.label }}</p>
        </div>
        <div v-for="group in selectedGroups" class="group" :key="group.id">
          <h3>{{ group.label }}</h3>
          <div
            v-for="item in selectedOptions.filter(option => option.group === group.id)"
            class="item"
            :key="item.id"
            @click="selected.splice(selected.indexOf(item.id), 1)"
          >
            <p>{{ item.id }} - {{ item.label }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
  .container {
    display: flex;
    gap: var(--spacing-s);
    width: 100%;
  }
  .column {
    width: 100%;
    height: 60vh;
    display: flex;
    flex-direction: column;
    padding: var(--spacing-s);
    border-radius: var(--components-card-and-modal-corners);
    border: 1px solid var(--colours-grey-3);
    background: var(--colours-grey-1);

    /* Card/Default */
    box-shadow: 0 1rem 2rem 0 rgba(0, 0, 0, 0.04);
  }
  .column-body {
    overflow: auto;
  }

  .item {
    margin: var(--spacing-xs);
    padding: 0 var(--spacing-s);
    cursor: pointer;
    user-select: none;

    p {
      margin: 0;
    }
  }

  .item:hover {
    background-color: var(--colours-grey-3);
    border-radius: var(--components-component-corners);
  }
</style>
